import React from 'react';

import { ConductStep } from '../preflight/ConductStep';

import type { LobbyStepProps } from './types';

/**
 * Lobby step — exam code of conduct (after GDPR consent, before screen share).
 * Records acknowledgement via the real mutation, then advances on poll.
 */
export function LobbyConductStep({ actions }: LobbyStepProps) {
  const handleConfirm = () => {
    actions.acknowledgeConduct();
  };

  return (
    <ConductStep
      onConfirm={handleConfirm}
      isSubmitting={actions.isAcknowledgingConduct}
    />
  );
}
